<!-- This component should replace the use of MembersAboutFields in other reports -->
<template>
  <ReportColumnToggle
    query-property="show_member_employment"
    has-submenu
  >
    <div class="app-toggle-dropdown pr-5">
      <slot></slot>
      <ReportShowMemberEmploymentColumnToggleFields />
    </div>
  </ReportColumnToggle>
</template>

<script>
import ReportShowMemberEmploymentColumnToggleFields from '~/components/reports/ReportShowMemberEmploymentColumnToggleFields.vue';

export default {
  name: 'ReportShowMemberEmploymentColumnToggle',
  components: { ReportShowMemberEmploymentColumnToggleFields },
};
</script>
